const init = () => {
    
    const shareBtnHandler = () => {
        const btn: string = `js-header-social-share-btn`;
        const socialContainer: string = `js-header__social`;
        $(`.${btn}`).on('click touch', ()=>{
            $(`.${socialContainer}`).toggleClass('header__social--active')
        })
    }

    shareBtnHandler();
}

export const social = {
	init: init
};